import React from 'react';
import { DataList, DataItem } from '@cad-arc';
import { EventDetailsTabView } from '@mark43/cad-api';
import { useApplicationType } from '../../../../../common/hooks/use-application-type';
import { formatEventFormStringValue } from '../../../../format-event-form-string-value';
import { formatMonthDayYearHoursMinutes } from '../../../../../common/helpers/utils';

function ArrvAndFirstArrvDataItems(props: Partial<EventDetailsTabView>) {
    return (
        <>
            <DataItem dataKey="Arrv">
                {formatEventFormStringValue(props.arrivalDateUtc, formatMonthDayYearHoursMinutes)}
            </DataItem>
            <DataItem dataKey="First Arrv">
                {formatEventFormStringValue(
                    props.firstArrivalDateUtc,
                    formatMonthDayYearHoursMinutes
                )}
            </DataItem>
        </>
    );
}

export function TimestampsSectionContent(
    props: Partial<EventDetailsTabView & { isScheduled: boolean }>
): React.ReactElement {
    const { isFirstResponder } = useApplicationType();

    return (
        <DataList spacing={4}>
            {props.isScheduled ? (
                <DataItem dataKey="Recv">
                    {formatEventFormStringValue(
                        props.receivedDateUtc,
                        formatMonthDayYearHoursMinutes
                    )}
                </DataItem>
            ) : (
                <>
                    <DataList>
                        <DataItem dataKey="Init">
                            {formatEventFormStringValue(
                                props.initiatedDateTimeUtc,
                                formatMonthDayYearHoursMinutes
                            )}
                        </DataItem>
                        <DataItem dataKey="Recv">
                            {formatEventFormStringValue(
                                props.receivedDateUtc,
                                formatMonthDayYearHoursMinutes
                            )}
                        </DataItem>
                        <DataList direction="row">
                            <DataItem
                                dataKey="Trans"
                                style={{ flexBasis: isFirstResponder ? '50%' : 'auto' }}
                            >
                                {formatEventFormStringValue(
                                    props.transmittedDateUtc,
                                    formatMonthDayYearHoursMinutes
                                )}
                            </DataItem>
                            <DataItem
                                dataKey="First Disp"
                                style={{ flexBasis: isFirstResponder ? '50%' : 'auto' }}
                            >
                                {formatEventFormStringValue(
                                    props.firstDispatchDateUtc,
                                    formatMonthDayYearHoursMinutes
                                )}
                            </DataItem>
                        </DataList>
                    </DataList>
                    <DataList
                        direction={isFirstResponder ? 'row' : undefined}
                        style={{ gap: isFirstResponder ? '80px' : undefined }}
                    >
                        <DataItem dataKey="Disp">
                            {formatEventFormStringValue(
                                props.dispatchDateUtc,
                                formatMonthDayYearHoursMinutes
                            )}
                        </DataItem>
                        {isFirstResponder && <ArrvAndFirstArrvDataItems {...props} />}
                        {!isFirstResponder && (
                            <DataList direction="row">
                                <ArrvAndFirstArrvDataItems {...props} />
                            </DataList>
                        )}
                    </DataList>
                </>
            )}
        </DataList>
    );
}
